import React, { useState } from "react";
import Project from "../../components/Project/index.jsx";
import ProjectModal from "../../components/ProjectModal/index.jsx";
import { Grid, Box, Typography, Container } from "@mui/material";
import projects from "./projectsData.js";
import bannerImg from "../../images/projects/hockley-mills/01-elevation-railway.jpg";

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <Box>
      <Box
        sx={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${bannerImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          py: { xs: 5, md: 8 },
          mb: { xs: 3, md: 4 }
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
            color: 'white',
            textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
            px: { xs: 2, sm: 0 }
          }}
        >
          Our Projects
        </Typography>
        <Typography
          sx={{
            color: 'rgba(255,255,255,0.9)',
            mt: 1.5,
            maxWidth: 720,
            mx: 'auto',
            px: { xs: 2, sm: 3 },
            fontSize: { xs: '1rem', md: '1.125rem' }
          }}
        >
          A selection of facade installation packages delivered by AV Facade Services Ltd
          across residential, education, science and secure developments.
        </Typography>
      </Box>

      {/* The banner supplies the gap above the grid; this one keeps the last row of
          cards off the footer, matching the rhythm the Contact page uses. */}
      <Container maxWidth="xl" sx={{ pb: { xs: 4, md: 8 } }}>
        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 4 }}
          sx={{
            justifyContent: "center",
            px: { xs: 2, sm: 3, md: 4 }
          }}
        >
          {projects.map((project) => (
            <Grid item xs={12} sm={6} md={4} key={project.title}>
              <Project
                project={project}
                onClick={() => setSelectedProject(project)}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      <ProjectModal
        open={!!selectedProject}
        onClose={() => setSelectedProject(null)}
        project={selectedProject}
      />
    </Box>
  );
};

export default Projects;
